<template>
    <v-sheet v-if="loadingProfile" class="white-card pa-3">
        <loading-spinner/>
    </v-sheet>
    <v-sheet v-else class="white-card pa-3 pb-6">
        <v-row>
            <v-col cols="12">
                <v-row align="center">
                    <v-col cols="6">
                        <kimsa-tabs
                            :tabs="tabs"
                            @change="currentTab = $event"
                            :value="currentTab"
                        />
                    </v-col>
                    <v-col cols="6" align="right">
                        <v-btn v-if="!!profileId" class="normal-btn" color="primary" outlined large @click="showDelete" :loading="loadingDelete">
                            Eliminar Perfil
                        </v-btn>
                        <v-btn class="normal-btn" color="skyblue" text depressed @click="save"
                               :disabled="disabled" :loading="loadingSave">
                            <v-icon class="mr-2">mdi-content-save-outline</v-icon>
                            Guardar Perfil
                        </v-btn>
                    </v-col>
                </v-row>
                <v-divider class="mt-1 divider-secondary"/>
            </v-col>
        </v-row>
        <loading-spinner v-if="loadingProfile"/>
        <template v-else>
            <v-row v-show="currentTab === 'profile'">
                <v-col cols="12" md="6">
                    <kimsa-text-field
                        label="Nombre del perfil"
                        @change="name = $event"
                        :value="name"
                        outlined dense
                        force-value
                    />
                </v-col>
                <v-col cols="12" class="subheader-heavy">
                    Selecciona las enfermedades que formarán este perfil
                </v-col>
                <v-col cols="12" md="6" :class="[{'border-right-secondary': !isMobile}]">
                    <div class="subheader-heavy primary-color pb-5">
                        Antecedentes personales
                    </div>
                    <kimsa-button-selector
                        :items="personalOptions"
                        :value="personal"
                        @change="personal = $event"
                        no-object force-cols
                    />
                </v-col>
                <v-col cols="12" md="6" :class="[{'border-left-secondary': !isMobile}]">
                    <div class="subheader-heavy primary-color pb-5">
                        Antecedentes familiares
                    </div>
                    <kimsa-button-selector
                        :items="familiarOptions"
                        :value="familiar"
                        @change="familiar = $event"
                        no-object force-cols
                    />
                </v-col>
            </v-row>
            <kimsa-confirm
                ref="delete"
                title="Eliminar"
                content="¿Esta seguro que desea eliminar este perfil?"
                :loading="loadingDelete"
                @confirm="onConfirmDelete"
                persistent alert-mode
                no-close-on-confirm
            />
        </template>
    </v-sheet>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaButtonSelector from "@/components/common/inputs/KimsaButtonSelector";
import {options} from "@/utils/Options";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import ExamsPicker from "@/components/exams/ExamsPicker";
import KimsaTabs from "@/components/KimsaTabs";
import httpService from "@/services/httpService";
import KimsaConfirm from "@/components/common/KimsaConfirm";

export default {
    name: "ProfileDetails",
    components: {KimsaConfirm, KimsaTabs, ExamsPicker, LoadingSpinner, KimsaButtonSelector, KimsaTextField},
    props: {
        profileId: {
            type: [String,Number],
            default: null,
        }
    },
    data() {
        return {
            loadingSave: false,
            loadingProfile: false,
            loadingDelete: false,
            profile: null,
            tabs: [
                {name: 'Perfil', value: 'profile'},
            ],
            currentTab: 'profile',
            name: '',
            personal: [],
            familiar: [],

            personalOptions: [],
            familiarOptions: [],
        }
    },
    computed: {
        disabled(vm = this) {
            return !vm.name
        },
    },
    async mounted() {
        const vm = this
        await vm.loadRecords()
        if (!!vm.profileId) await vm.loadProfile()
    },
    methods: {
        async loadRecords() {
            const vm = this
            let response = await httpService.get('records')
            // console.log('response loadRecords', response)
            vm.personalOptions = response.data.personal
            vm.familiarOptions = response.data.familiar
        },
        async loadProfile() {
            const vm = this
            vm.loadingProfile = true

            let response = await httpService.get(`profiles/${vm.profileId}`)
            vm.profile = response.data.profile
            vm.name = vm.profile.name
            vm.familiar = vm.getIdsFromArray(vm.profile.records, 'type', 'familiar')
            vm.personal = vm.getIdsFromArray(vm.profile.records, 'type', 'personal')

            vm.loadingProfile = false
        },
        reset() {
            const vm = this
            vm.profile = null
            vm.name = ''
            vm.personal = []
            vm.familiar = []
        },
        showDelete() {
            const vm = this
            vm.$refs.delete.show()
        },
        async onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true
            let response = await httpService.delete(`profiles/${vm.profileId}/delete`)
            vm.reset()
            vm.loadingDelete = false
            vm.toast(response.data.message)
            vm.$refs.delete.hide()
            vm.$emit('save')
        },
        async save() {
            const vm = this
            vm.loadingSave = true

            let payload = {
                laboratory_id: vm.currentEntityId,
                name: vm.name,
                records: [...vm.familiar, ...vm.personal],
            }

            let response;
            !!vm.profileId ?
                response = await httpService.put(`profiles/${vm.profileId}/edit`, payload) :
                response = await httpService.post('profiles/create', payload)

            vm.loadingSave = false
            vm.$emit('save')
            vm.toast(response.data.message)
            vm.reset()
        }
    },
    watch: {
        profileId(val) {
            if(val) this.loadProfile()
        },
    }
}
</script>

<style scoped>

</style>